<template>
    <div class="buy_inquiry_pages">
        <div v-if="showPage">
            <div class="list">
                <div :class="item.sel?'flex2 item active_color':'flex2 item'" v-for="(item,index) in list" :key="item.title" @click="select(index)">
                    <div>
                        <div class="type">{{item.PackageName}}</div>
                        <div class="money">{{item.PackagePrice}}元</div>
                        <div class="time"><span class="status_color">{{item.PackageDesc}}</span><span>,{{item.GraphicQuantity}}次图文问诊/{{ getPackageType(item.PackageType) }}</span></div>
                        <div class="avg">
                            平均{{item.GraphicAveragePrice.toFixed(2)}}元/次
                        </div>
                    </div>
                </div>
            </div>

            <h1 class="rule_title">使用规则</h1>
            <div class="rule_list">
                <div v-for="item in ruleLlist" :key="item">{{item}}</div>
            </div>

            <!-- <h1 class="rule_title">请选择支付方式</h1>
            <div class="flex1 wx_pay_box">
                <div class="flex2  wx_pay">
                    <img src="@/images/u1347.png"  class="wx_img">
                    <span class="">微信支付</span>
                </div>
                <div style="position:relative">
                    <img src="@/images/u1351.png" class="selct_img" />
                    <img src="@/images/u1353.png" class="true_img"  />
                </div>
            </div> -->

            <div class="pay_btn" v-show ="payMoney" @click="payPack">微信支付{{payMoney}}元</div>

        </div>
    </div>
</template>
<script>
import {BuyPackageList,UnifiedOrder} from "@/utils/api"
import {getCookie,getBrowser} from "@/utils/common"
import { Toast ,Dialog} from 'vant'
export default {
    data(){
        return{
            showPage:false,
            payIng:false,
            payMoney:"",
            ruleLlist:[
                "1.套餐所述均为图文问诊服务，不包含其他；",
                "2.当月问诊量超出套餐量，按照2元/次图文问诊标准收费，不再封顶；",
                "3.套餐开通后，如果原来已有套餐，不做叠加，将在原有套餐结束后使用新的套餐；",
                "4.套餐一旦支付成功，不可取消；",
                "5.其它未尽事宜，详询18102795846"
            ],

            list:[
                
            ]
        }
    },
    methods:{
        payPack(){
            if(this.payIng)return
            let data = this.list.filter(item=>item.sel)[0]
            let datas  ={
                OrderId:"",
                PackageCode :data.PackageCode,
                AppName:"莲藕健康",
                IpAddress:"192.168.1.5",
                ShopId:getCookie("shopId")
            }
            UnifiedOrder(datas).then(res=>{
                if(res.code==1){
                    let Browser = getBrowser()
                    let data = res.data

                    let appid = data.AppId

                    let partnerId = data.PartnerId

                    let prepayId = data.PrepayId

                    let nonceStr = data.NonceStr

                    let packageValue = data.Package

                    let timeStamp = data.TimeStamp

                    let sign = data.Sign
                    let jsonData  = JSON.stringify({
                        appid,partnerId,prepayId,nonceStr,packageValue,timeStamp,sign
                    })
                    console.log(jsonData)

                    if(Browser.isAndroid&&window.jsObj){
                        window.pay.wechatPay(jsonData)
                    }else{
                        
                        try {
                            window.webkit.messageHandlers.wechatPay.postMessage(jsonData);
                        } catch (error) {
                            // Toast("请在莲藕健康APP中进行支付操作")
                            this.payIng = false
                        }
                    }
                }else{
                    this.payIng = false
                    Toast(res.msg)
                }
            })

        },
        getPackageType(v) {
            let str = ''
            switch (v) {
                case 0:
                    str = '次'
                    break
                case 1:
                    str = '日'
                    break
                case 2:
                    str = '月'
                    break
                case 3:
                    str = '年'
                    break
            }
            return str
        },
        select(index){
            this.list.map(item=>{
                item.sel =false
            })
            this.list[index].sel = true
            this.payMoney = this.list[index].PackagePrice
        },
        getBuyPackageList(){
            BuyPackageList().then(res=>{
                if(res.code==1){
                    if(res.data.list){
                        res.data.list.map(item=>{
                            item.sel = false
                        })
                        if(res.data.list.length>=1){
                            res.data.list[0].sel = true
                            this.payMoney = res.data.list[0].PackagePrice
                        }
                    }
                    this.list = res.data.list
                    this.showPage = true
                }
            })
        }
    },
    mounted(){
        document.title=this.$route.meta.title
        this.getBuyPackageList()
        window.wxPaySuccess = function(res){
            Dialog.alert({
            title: '购买成功',
            }).then(() => {
                let Browser = getBrowser()
                if(Browser.isAndroid&&window.jsObj){
                    window.jsObj.webFinish(1);
                }else if(Browser.isIOS&&getCookie("access_token")){
                    window.webkit.messageHandlers.webFinish.postMessage(1);
                }else{
                    
                }
            });
        }
        window.wxPayFail = function(err){
            Toast.clear()
            setTimeout(() => {
                Toast(err)
            }, 500);
        }
    }
}
</script>
<style lang="scss" scoped src="@/scss/buy_inquiry.scss">

</style>